import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PedidoObject } from '../../models/pedido.class';
import { Company, ConnectionService } from '../../services/Connection/connection.service';
import { Cliente } from '../../Interfaces/customer';
import { ScrollService } from '../../services/Scroll/scroll.service';

@Component({
  selector: 'app-cashback',
  templateUrl: './cashback.component.html',
  styleUrl: './cashback.component.css'
})
export class CashbackComponent {
  @ViewChild('offCanva') offCanva!: ElementRef
  @Input() openInfo = false;
  @Input() order!: PedidoObject;
  @Output() closeCanvas : EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() optionSelected: EventEmitter<{ checked: boolean, value: number }> = new EventEmitter<{ checked: boolean, value: number }>();
  selectedOption: { checked: boolean, value: number } = { checked: false, value: 0};

  isChecked: boolean = false;
  user!: Cliente;
  company!: Company;
  offCanvasHeight: string | number = 'auto';
  initHeight: number = 160;
  private startY = 0;
  private isDragging = false;
  titleInfo: string = '';
  textinfo: string = ''
  iconClass: string = '';
  showPartialUsageVisual: boolean = false;

  constructor(private connection: ConnectionService, private scrollService: ScrollService){
    this.connection.user$.subscribe(user => {
      if(user){
        this.user = user;
      }
    })

    this.connection.company$.subscribe(company => {
      if(company){
        this.company = company;
      }
    })
  }

  validation() {

    //Bloqueia o uso de cashback se o valor do cashback for menor que o valor mínimo de utilização
    if (this.company.configs.cashbackLimited == 1 && this.user.cashback && Number(this.user.cashback) < Number(this.company.configs.cashbackLimitValue)) {
      return { type: 'limit', data: true};
    }

    //Bloqueia o uso de cashback se tiver cupom
    if(this.order.coupons){
      return { type: 'coupon', data: true};
    }

    //Bloqueia o uso de cashback se o valor do pedido for menor que o valor de multiplo
    if (this.company.configs.cashbackMultiple == 1 && this.user.cashback) {

      //Se o valor do pedido for menor que o valor de multiplo, bloqueia o uso de cashback
      if(this.order.orderPrice <= Number(this.company.configs.cashbackMultipleValue)){
        return { type: 'orderValue', data: true};
      }

      const multiplo = Number(this.company.configs.cashbackMultipleValue);
      const saldo = Number(this.user.cashback);

      const valorUtilizavel = Math.floor(saldo / multiplo) * multiplo;

      // ❌ não existe nenhum múltiplo válido
      if (valorUtilizavel <= 0) {
        return { type: 'multiple', data: true};
      }
    }

    return { type: 'none', data: false};
  }

  getValidCashbackUsage(saldo: number, pedido: number, multiplo: number): { value: number; hasPartial: boolean, type: string } {

    const limite = Math.min(saldo, pedido - 0.01);

    if (!multiplo || multiplo <= 0) {
      return {
        value: limite,
        hasPartial: saldo > pedido,
        type: 'balance-saldo'
      };
    }

    const valorMultiplo = Math.floor(limite / multiplo) * multiplo;

    return {
      value: valorMultiplo,
      hasPartial: valorMultiplo < saldo,
      type: 'balance-multiple'
    };
  }


  selectOption(event: any){
    const verification = this.validation();

    if(verification.data){
      
      setTimeout(() => {
        event.target.checked = false;
        this.isChecked = false;
        this.openCanva(verification.type);
      }, 200);
      return;
    }

    this.selectedOption.checked = event.target.checked;

    if(this.user.cashback && this.selectedOption.checked){

      const multiplo = this.company.configs.cashbackMultipleValue;

      const result = this.getValidCashbackUsage(this.user.cashback, this.order.orderPrice, multiplo);

      this.selectedOption.value = result.value;

      if (result.hasPartial) {
        this.openPartialUsageModal(result.type);
      }


      // const diferencial = this.order.orderPrice - this.user.cashback

      // if(diferencial <= 0){
      //   this.selectedOption.value = this.order.orderPrice - 0.01;
      //   if(this.selectedOption.checked){
      //     this.openPartialUsageModal();
      //   }
      // }
      // else{
      //   this.selectedOption.value = this.user.cashback;
      // }
    }

    this.optionSelected.emit(this.selectedOption);
  }

  //Abre o offcanva
  openCanva(type: string){
    this.iconClass = ''; // Clear icon for default validations
    this.showPartialUsageVisual = false;

    if(type == 'limit'){
      this.titleInfo = 'Valor mínimo';
      this.textinfo = 'Você precisa ter no mínimo R$ ' + this.company.configs.cashbackLimitValue.toString().replace('.', ',') + ' de cashback para utilizar nesta compra.';
    }
    else if(type == 'multiple'){
      this.titleInfo = 'Multiplos';
      this.textinfo = 'Você precisa ter  R$ ' + this.company.configs.cashbackMultipleValue.toString().replace('.', ',') + ' de cashback para utilizar nesta compra.';
    }
    else if(type == 'coupon'){
      this.titleInfo = 'Não é possível utilizar cashback';
      this.textinfo = 'Você não pode utilizar cashback em pedidos que já possuem cupons aplicados.';
    }
    else if(type == 'orderValue'){
      this.titleInfo = 'Não é possível utilizar cashback';
      this.textinfo = 'O valor do pedido é menor que o valor mínimo de utilização do cashback.';
    }

    this.scrollService.disableScroll();
    this.openInfo = true;
  }

  openPartialUsageModal(type: string) {
    this.showPartialUsageVisual = true;
    this.iconClass = ''; 
    if(type == 'balance-saldo'){
      this.titleInfo = 'Uso parcial do saldo';
      this.textinfo = 'Como seu saldo é maior que o pedido, utilizaremos apenas o valor parcial necessário para cobrir esta compra.';
    }
    else if(type == 'balance-multiple'){
      this.titleInfo = 'Uso parcial do saldo';
      this.textinfo = 'Você só pode usar seu cashback em multiplos de R$ ' + this.company.configs.cashbackMultipleValue.toString().replace('.', ',') + '.';
    }
    
    this.scrollService.disableScroll();
    this.openInfo = true;
  }

  //Quando o usuario clica
  onTouchStart(event: TouchEvent) {
    this.startY = event.touches[0].clientY;
    this.isDragging = true;
  }

  // Quando o usuario arrasta
  onTouchMove(event: TouchEvent) {
    if (!this.isDragging) return;

    const currentY = event.touches[0].clientY;
    const deltaY = currentY - this.startY;

    if (deltaY > 0) {
      this.offCanvasHeight = Math.max(0, this.initHeight - deltaY);
    }
  }

  // Finalizar o toque
  onTouchEnd() {
    this.isDragging = false;

    // Fechar se a altura for pequena
    if (Number(this.offCanvasHeight) < 50) {
      this.closeOffCanvas();
    } else {
      this.offCanvasHeight = this.initHeight; // Resetar altura
    }
  }

  // Fechar o OffCanvas
  closeOffCanvas() {
    this.openInfo = false;
    this.showPartialUsageVisual = false;
    this.offCanvasHeight = this.initHeight;
    this.closeCanvas.emit(false);

    setTimeout(() => {
      this.scrollService.enableScroll();
    }, 500);
  }







}
